module.exports = __webpack_public_path__ + "static/media/virtual-tour-dark.c3cc6ce1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/virtual-tour-dark.svg
// module id = 2416
// module chunks = 0